"use strict";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.rule2G = void 0;
/**
 * Implementation for rule 2G
 * @param node - node whose text alternative is being computed
 * @return - text alternative of node if node is a TEXT_NODE,
 * null otherwise.
 */
function rule2G(node) {
    if (node.nodeType === Node.TEXT_NODE) {
        return node.data;
    }
    return null;
}
exports.rule2G = rule2G;
//# sourceMappingURL=rule2G.js.map